import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'
import { transition } from '../../../shared/style-settings'

export const useNotificationItemComponentStyle = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(2),
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius * 2,
      backgroundColor: theme.palette.background.paper,
      transition: transition,
      position: 'relative',
      '&:hover': {
        borderColor: theme.palette.primary.light,
      },
      '&:last-child': {
        marginBottom: 0,
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },
    notificationRow: {
      alignItems: 'flex-start',
    },
    iconCell: {
      minHeight: 40,
      display: 'flex',
      alignItems: 'center',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flex: 1,
      minWidth: 0,
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    summary: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
      cursor: 'pointer',
      outline: 'none',
      minHeight: 40,
      '&:focus-visible $expandButton': {
        boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
      },
    },
    date: {
      color: theme.palette.text.secondary,
      fontSize: '0.875rem',
      fontWeight: 600,
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(0.5),
      },
    },
    title: {
      fontSize: '1.125rem',
      marginBottom: 0,
      fontWeight: 700,
      color: theme.palette.text.primary,
      lineHeight: 1.25,
    },
    text: {
      marginTop: 0,
      fontSize: '0.9375rem',
      fontWeight: 600,
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(1.5),
      lineHeight: 1.6,
    },
    contentHolder: {
      textAlign: 'left',
      width: '100%',
      flex: 1,
    },
    dateHolder: {
      fontSize: '0.875rem',
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing(1),
      color: theme.palette.text.secondary,
    },
    chip: {
      fontSize: '0.75rem',
      height: 24,
      fontWeight: 600,
    },
    details: {
      paddingTop: theme.spacing(1.5),
    },
    expandButton: {
      padding: theme.spacing(0.5),
      color: theme.palette.text.secondary,
      transition: transition,
    },
    expandButtonOpen: {
      transform: 'rotate(180deg)',
    },
    markAsRead: {
      display: 'inline-block',
      fontSize: '0.875rem',
      fontWeight: 700,
      color: theme.palette.primary.main,
      cursor: 'pointer',
      padding: theme.spacing(0.5, 1),
      borderRadius: theme.shape.borderRadius,
      transition: transition,
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
      },
    },
    readed: {
      display: 'inline-block',
      fontSize: '0.875rem',
      fontWeight: 500,
      color: theme.palette.text.secondary,
      fontStyle: 'italic',
    },
    notificationIcon: {
      color: theme.palette.primary.light,
      fontSize: 40,
      marginRight: theme.spacing(2),
      opacity: 0.7,
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    placeholderContainer: {
      display: 'flex',
      padding: theme.spacing(3),
      marginBottom: theme.spacing(2),
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius * 2,
      backgroundColor: theme.palette.background.paper,
      '&:last-child': {
        marginBottom: 0,
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },
    placeholderIconCell: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      marginRight: theme.spacing(2),
      paddingTop: theme.spacing(0.25),
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    placeholderIconSkeleton: {
      width: 40,
      height: 40,
    },
    placeholderContent: {
      flex: 1,
      minWidth: 0,
    },
    placeholderChipSkeleton: {
      width: 52,
      height: 24,
      borderRadius: 12,
      marginBottom: theme.spacing(1.5),
    },
    placeholderSummary: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
    },
    placeholderTitleBlock: {
      flex: 1,
      minWidth: 0,
    },
    placeholderExpandSkeleton: {
      width: 28,
      height: 28,
    },
    orderLinkContainer: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1.5),
    },
    orderLinkButton: {
      textTransform: 'none',
      fontSize: '0.875rem',
      fontWeight: 600,
    },
    bundleClickable: {
      cursor: 'pointer',
    },
  })
)
